module.exports = __webpack_public_path__ + "static/media/wentworth.97f9b14b.png";